'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLOUDINARY_URL = exports.CLOUDINARY_URL = 'https://res.cloudinary.com/ninety-seconds/image';
//# sourceMappingURL=cloudinary.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/config/data/cloudinary.js
// module id = 1913
// module chunks = 0